import { render, staticRenderFns } from "./SetupScopesWizard.vue?vue&type=template&id=ff90c418"
import script from "./SetupScopesWizard.vue?vue&type=script&lang=ts"
export * from "./SetupScopesWizard.vue?vue&type=script&lang=ts"
import style0 from "./SetupScopesWizard.vue?vue&type=style&index=0&id=ff90c418&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff90c418')) {
      api.createRecord('ff90c418', component.options)
    } else {
      api.reload('ff90c418', component.options)
    }
    module.hot.accept("./SetupScopesWizard.vue?vue&type=template&id=ff90c418", function () {
      api.rerender('ff90c418', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Guide/components/SetupWizard/SetupScopesWizard.vue"
export default component.exports